/**
 * Reglas de fuerza de contraseña. Lógica pura, sin React: la usan el medidor
 * visual (`components/auth/FuerzaContrasena`) y los formularios que deciden si
 * el botón de envío se habilita.
 */

/** Largo mínimo que exige el backend (`min:8` en los FormRequest de fc-api). */
export const LARGO_MINIMO = 8

/**
 * Puntaje de 0 a 4. Cada criterio suma uno: largo, ambas cajas, un dígito, un
 * símbolo. Deliberadamente simple y explicable — la persona tiene que poder
 * mirar la lista de reglas y entender por qué le falta una barra.
 */
export function puntajeContrasena(clave: string): number {
  if (!clave) return 0
  let n = 0
  if (clave.length >= LARGO_MINIMO) n++
  if (/[A-Z]/.test(clave) && /[a-z]/.test(clave)) n++
  if (/\d/.test(clave)) n++
  if (/[^A-Za-z0-9]/.test(clave)) n++
  return n
}

/**
 * ¿La contraseña alcanza para crear la cuenta?
 *
 * El backend sólo exige 8 caracteres. Acá pedimos además un segundo criterio
 * (puntaje ≥ 2): con 8 minúsculas seguidas la barra queda en rojo y la persona
 * la ve "aceptada", que es peor que no mostrar nada. El símbolo NO es
 * obligatorio — es lo que separa "Buena" de "Fuerte", no lo que bloquea.
 */
export function contrasenaAceptable(clave: string): boolean {
  return clave.length >= LARGO_MINIMO && puntajeContrasena(clave) >= 2
}

/** Las tres reglas que el medidor muestra escritas, en orden. */
export function reglasContrasena(clave: string): { label: string; ok: boolean }[] {
  return [
    { label: `${LARGO_MINIMO} caracteres`, ok: clave.length >= LARGO_MINIMO },
    { label: 'Mayúscula y minúscula', ok: /[A-Z]/.test(clave) && /[a-z]/.test(clave) },
    { label: 'Un número', ok: /\d/.test(clave) },
  ]
}
